export enum Routes {
  PurchasingRouter = '/purchasing/*',
  VendorsPage = 'vendors',
  PurchaseOrderPage = 'purchase-order',
  ReceivingPage = 'receiving',
}
